import { Navigate, useLocation } from 'react-router';

import { paths } from '@/app/router/paths';

/**
 * `/login`: het adres van oude links en van de website. Gaat meteen door naar
 * `/inloggen`, met zijn `?email=` (en wat er verder achter stond).
 */
export function LegacyLoginRedirect() {
    const { search, hash } = useLocation();

    return <Navigate to={{ pathname: paths.login, search, hash }} replace />;
}
